// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4fd721399349fd91edd5","678":"5d87e859f1bffc7bf168","883":"4aa5d1bef9e6630c62bd"}[chunkId] + ".js";
};